//import logo from './logo.svg';
import React from 'react';
import {Route, Routes, Link, useLocation} from 'react-router-dom';
import Home from './pages/Home.js';
import Logout from './pages/login/logout.js';

//import QuillEditor from './pages/quill.js';
import Orderboards from './pages/orderboards/orderboards.js';
import Order from './pages/orderboards/order.js';
import OrderReview from './pages/orderboards/orderreview.js';
import Receive from './pages/orderboards/receive.js';
import ChangeReceiveDate from './pages/orderboards/changereceivedate.js';
import VisitorCheck from './pages/orderboards/visitorcheck.js';
import Orderboards_select_man from './pages/orderboards/orderboards_select_man.js';
import Orderboards_select_car from './pages/orderboards/orderboards_select_car.js';
import ChangeDate from './pages/orderboards/changedata.js';
import ChangeManyDate from './pages/orderboards/changemanydata.js';
import ChangeDeposit from './pages/orderboards/checkdeposit.js';
import DepositcompanyList from './pages/orderboards/depositcompanylist.js';
import DataInput from './pages/orderboards/datainput.js';
import NotApproch from './pages/orderboards/notapproch.js';

import LotMaterial from './pages/material/lotmaterial.js';

import VisitlogCreate from './pages/visitlog/visitlogcreate.js';

import SignIn from './pages/login/SignIn.js';
import SignUp from './pages/login/SignUp.js';
import Company_main from './pages/company/company_main.js';
import Company_sub from './pages/company/company_sub.js';
import Company_sub_material from './pages/company/company_sub_material.js';
import Dataupdate from './pages/data/dataupdate.js';
import AdminMain from './pages/admin/admin_main.js';

import Stock from './pages/stock/stock.js';
import Analysis from './pages/analysis/analysis.js';
import './App.css';
//import { useState } from "react";

import { TextField } from '@mui/material';

const username = localStorage.getItem("happycallname");
const usergrade = localStorage.getItem("happycallgrade");

function App() {
  const location = useLocation();
  // nav, header가 필요 없는 경로 목록
  const hiddenLayoutPaths = ['/changereceivedate','/changemanydate','/changedate','/notapproch'];
  const hideLayout = hiddenLayoutPaths.includes(location.pathname);

return (
  <div className="App">
  {!hideLayout && (
    <header className="header">
      <div id="logos"  className="animated-title">
      <div className="track">
        <Link to='/' className='logo_underline'>
          &nbsp;Happy<span className="red">C</span>all
          Happy<span  className="red">C</span>all
        </Link>
      </div>
    </div>
    <div className='headerpart'>
      <TextField id="standard-basic" label="Searching..." variant="standard" />
    </div>
    {username === null ?
      <div>
      <div className='login'><Link to='/SignIn'>Log In</Link></div>
      </div>
    :
      <div className='login'><Link to='/Logout'>({username}) LogOut</Link></div>   
    }
    </header>
  )}
  {!hideLayout && ( username === null ?
    <div>Not LOG</div>
    :
    <nav className='nav'>
      {usergrade === 'admin' ?
      <>
        <Link to='/' style={{textDecoration:'none'}}><div className='nav_menu'>home</div></Link>
        <Link to='/Orderboards' style={{textDecoration:'none'}}><div className='nav_menu'>Orderboards</div></Link>
        <Link to='/Company_main' style={{textDecoration:'none'}}><div className='nav_menu'>Company_main</div></Link>
        <Link to='/LotMaterial' style={{textDecoration:'none'}}><div className='nav_menu'>LotMaterial</div></Link>
        <Link to='/Stock' style={{textDecoration:'none'}}><div className='nav_menu'>Stock</div></Link>
        <Link to='/VisitlogCreate' style={{textDecoration:'none'}}><div className='nav_menu'>create</div></Link>
        <Link to='/Dataupdate' style={{textDecoration:'none'}}><div className='nav_menu'>Dataupdate</div></Link>
        <Link to='/Analysis' style={{textDecoration:'none'}}><div className='nav_menu'>요청</div></Link>
        <Link to='/AdminMain' style={{textDecoration:'none'}}><div className='nav_menu'>AdminMain</div></Link>
      </>
      :
      usergrade === 'normal' ? 
      <>
        <Link to='/' style={{textDecoration:'none'}}><div className='nav_menu'>home</div></Link>
        <Link to='/Orderboards' style={{textDecoration:'none'}}><div className='nav_menu'>Orderboards</div></Link>
        <Link to='/Company_main' style={{textDecoration:'none'}}><div className='nav_menu'>Company_main</div></Link>
        <Link to='/LotMaterial' style={{textDecoration:'none'}}><div className='nav_menu'>LotMaterial</div></Link>
        <Link to='/Stock' style={{textDecoration:'none'}}><div className='nav_menu'>Stock</div></Link>
        <Link to='/Analysis' style={{textDecoration:'none'}}><div className='nav_menu'>Analysis</div></Link>
        <Link to='/VisitlogCreate' style={{textDecoration:'none'}}><div className='nav_menu'>create</div></Link>
        <Link to='/Analysis' style={{textDecoration:'none'}}><div className='nav_menu'>요청</div></Link>
        <Link to='/Dataupdate' style={{textDecoration:'none'}}><div className='nav_menu'>Dataupdate</div></Link>
      </>
      :
      <>
      <Link to='/' style={{textDecoration:'none'}}><div className='nav_menu'>home</div></Link>
      </>
      }
    </nav>
  )}
  <div className='body'>
    <Routes>
      <Route path='/' element={<Home />} />
      <Route path='/Logout' element={<Logout />} />
      <Route path='/SignIn' element={<SignIn />} />
      <Route path='/SignUp' element={<SignUp />} />
      <Route path='/Orderboards' element={<Orderboards />} />
      <Route path='/Order' element={<Order />} />
      <Route path='/Receive' element={<Receive />} />
      <Route path='/ChangeReceiveDate' element={<ChangeReceiveDate />} />
      <Route path='/OrderReview' element={<OrderReview />} />
      <Route path='/VisitorCheck' element={<VisitorCheck />} />
      <Route path='/Orderboards_select_man' element={<Orderboards_select_man />} />
      <Route path='/Orderboards_select_car' element={<Orderboards_select_car />} />
      <Route path='/ChangeDate' element={<ChangeDate />} />
      <Route path='/ChangeManyDate' element={<ChangeManyDate />} />
      <Route path='/ChangeDeposit' element={<ChangeDeposit />} />
      <Route path='/DataInput' element={<DataInput/>} />
      <Route path='/DepositcompanyList' element={<DepositcompanyList />} />
      <Route path='/LotMaterial' element={<LotMaterial />} />
      <Route path='/Company_main' element={<Company_main />} />
      <Route path='/Company_sub' element={<Company_sub />} />
      <Route path='/Company_sub_material' element={<Company_sub_material />} />
      <Route path='/Dataupdate' element={<Dataupdate />} />
      <Route path='/AdminMain' element={<AdminMain />} />
      <Route path='/Stock' element={<Stock />} />
      <Route path='/Analysis' element={<Analysis />} />
      <Route path='/VisitlogCreate' element={<VisitlogCreate />} />
      <Route path='/NotApproch' element={<NotApproch />} />
    </Routes>
  </div>
</div>
);

}
export default App;
